const PRINT_RULES = `
	html, body { background: #fff !important; color: #000; margin: 0; }
	[data-print-hide] { display: none !important; }
	article, article * { overflow: visible !important; max-height: none !important; }
	article img, article picture, article figure:has(img), article footer { display: none !important; }
	article a, article a *, article button { color: inherit !important; text-decoration: none !important; border: 0 !important; background: none !important; box-shadow: none !important; cursor: text; }
	article { height: auto !important; max-width: none !important; padding: 0 !important; margin: 0 !important; }
	article > * { padding-left: 0 !important; padding-right: 0 !important; margin-left: 0 !important; }
`;

function collectStyles(): string {
	const chunks: string[] = [];
	for (const sheet of Array.from(document.styleSheets)) {
		try {
			chunks.push(Array.from(sheet.cssRules, (rule) => rule.cssText).join('\n'));
		} catch {
			continue;
		}
	}
	return chunks.join('\n').replace(/\(prefers-color-scheme:\s*dark\)/g, '(prefers-color-scheme: never)');
}

export function printElement(element: Element, title: string) {
	const frame = document.createElement('iframe');
	frame.setAttribute('aria-hidden', 'true');
	frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';

	frame.srcdoc = `<!doctype html><html lang="ru"><head><meta charset="utf-8"><base href="${location.origin}/"><title>${title.replace(/</g, '&lt;')}</title><style>${collectStyles()}</style><style>${PRINT_RULES}</style></head><body class="${document.body.className}">${element.outerHTML}</body></html>`;

	frame.onload = () => {
		const frameWindow = frame.contentWindow;
		if (!frameWindow) return;
		const images = Array.from(frameWindow.document.images).filter((image) => !image.complete);
		Promise.all(images.map((image) => new Promise((resolve) => (image.onload = image.onerror = resolve)))).then(() => {
			frameWindow.focus();
			frameWindow.onafterprint = () => frame.remove();
			frameWindow.print();
		});
	};

	document.body.appendChild(frame);
}
